export const checkCollaboratorPincipal = function (collaboratorPincipalId: number) {
  const errors: any = {};
  if (collaboratorPincipalId === 0) {
    errors.collaborators = 'Debe seleccionar un colaborador representante.';
  }
  return errors;
};
